export module Utils {

    export function isEmpty(obj) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    export function getFieldNames(model, excludes = [], additional = []) {
        const keys = Object.getOwnPropertyNames(model);
        const filtered = keys.filter(k => !excludes.includes(k));

        // Alphabetical DESC order and addition of ID at the first item
        return filtered.sort((a, b) => b.localeCompare(a)).concat(additional).reverse();
    }

    export const excludeCheckRespCust = [
		'observation_visible',
		'checklist_origin',
		'question_groups',
		'real_responses',
		'header_items',
	];

    export const checkRespKeys = ({
        model, excludes, includes
    }) => [
        'id',
        ...getFieldNames(
            model,
            [
                ...excludes || [],
                ...excludeCheckRespCust
            ],
            includes || []
        )
    ];

    export function safeStringify(data: any): string | null {
        try {
            return JSON.stringify(data);
        } catch (error) {
            return null;
        }
    }

    export function safeJsonParse<T>(data: any): T | null {
        try {
            return JSON.parse(data);
        } catch (error) {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/static/utils.ts